import "core-js/modules/es6.regexp.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "accordion"
  }, [_c('MdmLink', {
    class: {
      'd-inline-flex justify-content-center align-items-center mb-2': _vm.titleCenter,
      'd-flex w-100 py-3 py-sm-2': !_vm.titleCenter
    },
    attrs: {
      "is-prevent-default-link": true,
      "url": _vm.url,
      "is-scramble-link": _vm.isScrambleLink,
      "aria-expanded": (!_vm.isFolded).toString()
    },
    on: {
      "click": _vm.toggleFold
    }
  }, [_c('span', {
    staticClass: "title-text",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _vm.productLine ? _c('span', {
    staticClass: "text-uppercase ml-1",
    domProps: {
      "textContent": _vm._s(_vm.productLine)
    }
  }) : _vm._e(), _vm._v(" "), _vm.subtitle ? _c('span', {
    staticClass: "subtitle-text",
    domProps: {
      "textContent": _vm._s(_vm.subtitle)
    }
  }) : _vm._e(), _vm._v(" "), _vm.withChevronIcon ? _c('mdm-icon', {
    staticClass: "my-1",
    class: {
      'chevron-open': !_vm.isFolded,
      'chevron ml-1': _vm.withChevronIcon,
      'ml-auto': !_vm.withChevronIcon
    },
    attrs: {
      "size": _vm.withChevronIcon ? '16' : '14',
      "name": 'chevron-down'
    }
  }) : _vm._e(), _vm._v(" "), !_vm.withChevronIcon ? _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [!_vm.toggleCondition ? _c('svg', {
    key: "one",
    staticClass: "ml-auto my-auto accordion-icons",
    attrs: {
      "viewBox": "0 0 14 14"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#plus"
    }
  })]) : _vm._e(), _vm._v(" "), _vm.toggleCondition ? _c('svg', {
    key: "two",
    staticClass: "ml-auto my-auto accordion-icons",
    attrs: {
      "viewBox": "0 0 14 14"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#minus"
    }
  })]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "smoothAccordion"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.toggleCondition,
      expression: "toggleCondition"
    }],
    staticClass: "body"
  }, [_vm._t("default")], 2)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };